import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      display: 'flex',
      justifyContent: 'center',
      gap: '10px',
      alignItems: 'center',
      marginTop: '20px',
      flexDirection: 'column',
      userSelect: 'none',
      '@media (max-width: 426px)': {
        gap: '15px'
      }
    },
    title: {
      fontSize: '1.5rem',
      fontWeight: 700,
      fontStyle: 'italic',
      color: palette.text.primary
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
